import dynamic from "next/dynamic";

export const DynamicContent015 = dynamic(() => import("./Content015"), {
  suspense: true,
});
